// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__bzQCb","h2":"Heading_h2__IiqqI","h3":"Heading_h3__gXFUk","center":"Heading_center__EPLDo"};